<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-contact`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 13c0-5.523-4.48-10-10-10S10 7.477 10 13s4.48 10 10 10 10-4.477 10-10zm8 25c0-6.627-5.37-12-12-12H14C7.37 26 2 31.373 2 38v5.077c0 1.105.9 2 2 2h32c1.1 0 2-.895 2-2V38zM6 38c0-4.42 3.58-8 8-8h12c4.42 0 8 3.58 8 8v3.077H6V38zm39-12a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4zm0-8a1 1 0 011 1v2a1 1 0 01-1 1H35a1 1 0 01-1-1v-2a1 1 0 011-1h10zm-31-5c0-3.313 2.688-6 6-6s6 2.687 6 6-2.688 6-6 6-6-2.687-6-6z"/></svg>
</template>
<script>

export default {
  name: 'IconContact',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
